require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scribbling-about-whoa.json") })
        }
      }, "path---scribbling-about-whoa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scribbling-about-whoa!./.cache/json/scribbling-about-whoa.json
// module id = 565
// module chunks = 231608221292675